import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getPIMExportApi } from "@tecumseh/Services/PIMExportHistoryService";
import { getPIMAttributesAPI, PIMAttributesApiResultModel } from "@tecumseh/Services/PIMGetAttributes";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<any>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/PIMAttributes/StartSettingContents",
    });
};

export const GetAttributes: HandlerType = async props => {
        try {
          
            const result = await getPIMAttributesAPI(props.parameter.apiParameter);
            props.dispatch({
                type: "Custom/PIMAttributes/SetContents",
                attributeResults: result,
            });
        } catch (error) {
            // if (isApiError(error) && error.status === 400) {
            //     props.apiResult.errorMessage = error.errorJson.message;
            //     return;
            // }
            throw error;
        }
};


export const chain = [StartLoading, GetAttributes];

const getPIMAttributes = createHandlerChainRunner(chain, "getPIMAttributes");
export default getPIMAttributes;
